import { useSuspenseQuery } from '@tanstack/react-query'

// eslint-disable-next-line boundaries/element-types
import { plantasKeys } from '@/features/plantas/utils/queries'
import { GetPlantasBlocoService } from '@/shared/services/get-plantas-bloco.service'

export const useSuspensePlantasBloco = (idExternoBloco: number) => {
  return useSuspenseQuery({
    queryKey: plantasKeys.listaPorBloco(idExternoBloco),
    queryFn: async () => new GetPlantasBlocoService().execute(idExternoBloco).then((res) => res.data),
  })
}
